import React from "react";
import { BuildDocument, RegisterFont } from "./InvoiceBill";
import { Image, Text, View } from "@react-pdf/renderer";
import { BillStylesA4 as styles } from "./BillStyle";
import { GetThaiFormatDateTime } from "../../core/Helper";
import { TheMonths } from "../../core/MyCalendar";
import { getDecimalString } from "../../core/Helper2";

export default async function BuildPayDFBill(props) {
  const { data, pdf, setPdf, items } = props;
  RegisterFont();

  // console.log(data);
  // console.log(items);

  setPdf(
    <BuildDocument
      {...{
        docHeader: await GetRadConnHeader({ data, items }),
        customer: await GetRadConnCustomerTypeA({ data, items }),
        items: await GetRadConnPayDFItems({ data, items }),
        footer: await GetRadPaySummaryItems({ data, items }),
      }}
    />
  );
}

/** Components */

export const keywordColor = "#021688";
export const GetRadConnHeader = async ({ data }) => {
  // console.log("check branch", data);
  const { Branch, DocuType } = data?.DocuBranch?.BranchDocu;

  const getTextAddr = (text) => (
    <Text style={{ ...styles.textSmall, ...{ marginLeft: "2px" } }}>
      {text}
    </Text>
  );
  return (
    <View style={{ paddingTop: "10px", paddingBottom: "10px" }}>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View>
          <Text
            style={{
              ...styles.textVeryLarge,
              ...{
                fontSize: "20px",
                color: keywordColor,
                fontFamily: "Browallia",
              },
            }}
          >
            {Branch.Company?.CompNameTh}
          </Text>
          {getTextAddr(Branch.Company?.CompAddrTh)}
          {getTextAddr(Branch.Company?.CompAddrTh2)}
          {getTextAddr(`เลขประจำตัวผู้เสียภาษี ${Branch.Company?.Taxid}`)}
          {getTextAddr(`โทร.${Branch.Company?.Phone}`)}
        </View>

        <View
          style={{
            ...styles.headerLogo,
            ...{
              height: "100px",
              marginTop: "10px",
              overflow: "hidden",
            },
          }}
        >
          <Image
            style={{
              ...styles.logo,
              ...{ width: "100px", height: "80px", marginTop: "-20px" },
            }}
            src={"/logos/logo_comp_" + Branch.Company?.CompId + ".png"}
          />
        </View>
      </View>
    </View>
  );
};

export const GetRadConnCustomerTypeA = async ({ data }) => {
  const { DocuType } = data?.DocuBranch?.BranchDocu;
  const textRight = {
    ...styles.textLabel,
    ...{ textAlign: "center", padding: "0px" },
  };
  const docuNameStyle = {
    ...styles.textLarge,
    color: keywordColor,
  };
  return (
    <View fixed>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Text style={docuNameStyle}>{DocuType?.DocuTypeText} </Text>
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View>
          <Text style={styles.textLabel}>
            ประจำเดือน:{" "}
            {`${TheMonths[(data?.PeriodMonth ?? 0) + 1]?.name} ${
              data?.PeriodYear + 543
            }`}
          </Text>
          <Text style={styles.textLabel}>{data?.BranchPay?.BrchName} </Text>
        </View>
        <View
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "end",
          }}
        >
          <Text style={textRight}>เลขที่: {data?.DocuNo} </Text>
          <Text style={textRight}>{data?.Staff?.FullName} </Text>

          <Text
            style={textRight}
            render={({ pageNumber, totalPages }) =>
              `หน้า : ${pageNumber}/${totalPages}`
            }
          ></Text>
        </View>
      </View>
    </View>
  );
};

export const GetRadConnPayDFItems = async ({ data, items }) => {
  let head = await GetRadPayRowHeader();
  let rows = await GetRadPayRowItems({ items });
  return (
    <View>
      {head}
      {rows}
    </View>
  );

  // head;
};

const getHeader = (text, x) => (
  <Text
    style={{
      ...styles.itemSmall,
      ...styles.itemHeader,
      ...{
        display: "flex",
        width: x,
        textAlign: "left",
        alignItems: "center",
        justifyContent: "center",
      },
    }}
  >
    {text}
  </Text>
);
const getRow = (text, x) => (
  <Text style={{ ...styles.textSmall, ...{ width: x } }}>{text}</Text>
);
export const GetRadPayRowHeader = async (props) => (
  <View
    style={{
      ...styles.itemRow,
      ...{ justifyContent: "center", alignItems: "center" },
    }}
    fixed
  >
    {getHeader("ลำดับ", "30px")}
    {getHeader("วัน-เวลา ที่ส่ง", "80px")}
    {getHeader("ชื่อคนไข้", "120px")}
    {getHeader("HN", "60px")}
    <Text style={{ ...styles.itemFlex, ...styles.itemHeader }}>
      {"รายการตรวจ"}
    </Text>
    <Text
      style={{
        ...styles.itemTotal,
        ...styles.itemHeader,
        ...{ width: "40px" },
      }}
    >
      {"DF"}
    </Text>
  </View>
);

export const GetRadPayRowItems = async (props) => {
  const { items } = props;
  return (
    <View>
      {items?.map((item, i) => {
        return (
          <View style={styles.itemRow}>
            <Text style={{ ...styles.textSmall, ...{ width: "30px" } }}>
              {i + 1 + "."}
            </Text>
            {getRow(GetThaiFormatDateTime(item?.request_date), "80")}
            {getRow(item?.patients_name, "120px")}
            {getRow(item?.hn, "60px")}
            <Text style={{ ...styles.itemFlex }}>{item?.item_name}</Text>
            <Text style={{ ...styles.itemTotal, ...{ width: "40px" } }}>
              {getDecimalString(item?.df_fee, 2)}
            </Text>
          </View>
        );
      })}
    </View>
  );
};

/**
 *
 * @param {*} props
 * @returns
 */
export const GetRadPaySummaryItems = async (props) => {
  const { items, data } = props;
  const { Staff } = data;
  let sum = 0;
  items?.map((item, i) => (sum = sum + Number(item?.df_fee)));

  let tax = sum * 0.03;
  return (
    <View style={{ marginBottom: "20px" }}>
      <View style={styles.itemRow}>
        <Text style={{ ...styles.textSmall, ...{ width: "30px" } }}>{""}</Text>
        {getRow("", "80")}
        {getRow("", "100px")}
        {getRow("", "60px")}
        <Text style={{ ...styles.itemFlex }}>{"รวม"}</Text>
        <Text style={{ ...styles.itemTotal, ...{ width: "40px" } }}>
          {getDecimalString(sum)}
        </Text>
      </View>

      {Staff?.IsHoldTax === true ? (
        <View style={styles.itemRow}>
          <Text style={{ ...styles.textSmall, ...{ width: "30px" } }}>
            {""}
          </Text>
          {getRow("", "80")}
          {getRow("", "100px")}
          {getRow("", "60px")}
          <Text style={{ ...styles.itemFlex }}>{"หัก ณ ที่จ่าย 3 %"}</Text>
          <Text style={{ ...styles.itemTotal, ...{ width: "40px" } }}>
            {getDecimalString(tax)}
          </Text>
        </View>
      ) : (
        <View></View>
      )}
      {Staff?.IsHoldTax === true ? (
        <View style={styles.itemRow}>
          <Text style={{ ...styles.textSmall, ...{ width: "30px" } }}>
            {""}
          </Text>
          {getRow("", "80")}
          {getRow("", "100px")}
          {getRow("", "60px")}
          <Text style={{ ...styles.itemFlex }}>{"เงินได้สุทธิ"}</Text>
          <Text style={{ ...styles.itemTotal, ...{ width: "40px" } }}>
            {getDecimalString(sum - tax)}
          </Text>
        </View>
      ) : (
        <View></View>
      )}
    </View>
  );
};
